module.exports = __webpack_public_path__ + "img/waring.17e1382e.svg";